import { defineMessages, FormattedMessage } from "react-intl";
import React from "react";
import classNames from "classnames";
import * as styles from "./InstallStyles.module.scss";
import { Link, Title } from "@yoast/ui-library";
import { StepNavigation } from "./StepNavigation";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";

const messages = defineMessages( {
	title: {
		id: "brandInsightsStep.title",
		defaultMessage: "Thanks for your purchase. Let's get you set up!",
	},
	brandInsightsIntro: {
		id: "brandInsightsStep.intro",
		defaultMessage: "You now have access to Yoast AI Brand Insights and are all set to see how your brand is performing on AI.",
	},
	invoiceInformation: {
		id: "brandInsightsStep.invoiceInformation",
		defaultMessage: "You can access Brand Insights anytime through your MyYoast account.",
	},
	visitBrandInsights: {
		id: "brandInsightsStep.visitBrandInsights",
		defaultMessage: "Go straight to Brand Insights",
	},
} );


/**
 * Renders the ConnectYourSiteStep component.
 * @returns {Element} The rendered component.
 */
export const BrandInsightsStep = () => {
	return <div className={ classNames( styles.downloadingStep, styles.ySpacing ) }>
		<Title className={ styles.textCenter }><FormattedMessage { ...messages.title } /></Title>
		<hr />
		<div>
			<p className={ styles.textCenter }>
				<FormattedMessage { ...messages.brandInsightsIntro } />
			</p>
			<p className={ classNames( "yst-mt-4", styles.textCenter ) }>
				<FormattedMessage { ...messages.invoiceInformation } />
			</p>
		</div>
		<div className="yst-mb-8 yst-text-center">
			<Link href="/ai-brand-insights-tool" target="_blank" rel="noreferrer noopener">
				<span className={ styles.goToBrandInsightsLink }>
					<FormattedMessage { ...messages.visitBrandInsights } />
					<ArrowTopRightOnSquareIcon className="yst-ml-2 yst-h-4 yst-w-4" />
				</span>
			</Link>
		</div>
		<hr />
		<StepNavigation />
	</div>;
};
